var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsBuilder = function SvgFormsBuilder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 3.33h33.334v33.334H3.333V3.33zM30 9.997h-6.667M30 16.664h-8.889M30 23.33h-8.889M27.778 29.997H21.11",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.997h6.667v6.667H10V9.997zM10 23.33h6.667v6.667H10V23.33z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsBuilder;